/**
 * @group Patient
 * @summary Payment method channel constants for patient domain
 * 
 * <blockquote>
 * Defines the available payment channels supported by Paystack integration.
 * These constants are domain-specific to the patient payment methods and should
 * not be placed in the global @shared/constants package.
 * </blockquote>
 */

/**
 * Payment method channels supported by Paystack

@example
```typescript
const channel = PAYMENT_METHOD_CHANNELS.CARD;
```
 * @internal
 */
export const PAYMENT_METHOD_CHANNELS = {
  /** Credit/Debit card payments */
  CARD: 'card',
  /** Bank account payments */
  BANK: 'bank',
  /** USSD mobile payments */
  USSD: 'ussd',
  /** Mobile money payments */
  MOBILE_MONEY: 'mobile_money',
  /** Bank transfer payments */
  BANK_TRANSFER: 'bank_transfer',
} as const;